import axios from 'axios';

const apiPagamento = axios.create({
  baseURL: process.env.REACT_APP_PAGAMENTO_F10_URL,
});

export default apiPagamento;
